import {useQuery} from "@tanstack/react-query";
import {requestJson} from "../apiUtils";
import {type UserRole} from "../../util/userRole";

export type AuthMeResponse = {
    username: string;
    role: UserRole;
};

export const authMeKey = ["auth", "me"] as const;

export function fetchAuthMe(): Promise<AuthMeResponse> {
    return requestJson<AuthMeResponse>("/auth/me");
}

export function useAuthMe(enabled: boolean) {
    return useQuery({
        queryKey: authMeKey,
        queryFn: fetchAuthMe,
        enabled,
        retry: false,
    });
}
